import { Fragment, useEffect, useRef, useState } from 'react';
import { Element, Link } from 'react-scroll';
import profilePic from 'img/the-smallphish.png';
import './Hero.css';

const TECH_STACK = ['Java', 'NodeJS', 'Kafka', 'Postgres', 'Microservices'];

function Hero() {
  const avatarRef = useRef(null);
  const [avatarLoaded, setAvatarLoaded] = useState(false);

  // Cover the case where the image is already cached and fires `load`
  // before React attaches the handler — otherwise the avatar stays hidden.
  useEffect(() => {
    if (avatarRef.current?.complete) setAvatarLoaded(true);
  }, []);

  return (
    <Element name="hero" className="hero">
      <img
        ref={avatarRef}
        src={profilePic}
        className={`hero__avatar${avatarLoaded ? ' hero__avatar--loaded' : ''}`}
        alt="Portrait of Adam, the Smallphish"
        onLoad={() => setAvatarLoaded(true)}
      />
      <h1 className="hero__title">&lt;SMALLPHISH /&gt;</h1>

      <p className="hero__tagline">
        If your tech needs a problem solved&hellip;
        <br />
        if no one else can help&hellip;
        <br />
          and if you can <Link
              to="connect"
              smooth
              duration={500}
              offset={-64}
              className="hero-nav__link"
          >
            find him...
          </Link>
        <br />
        maybe you can hire...
        <br/> <strong className="hero__name">The Smallphish</strong>.
      </p>

      <p className="hero__intro">
        <span className="hero__intro-line">
          {TECH_STACK.map((tech, index) => (
            <Fragment key={tech}>
              {index > 0 && (
                <span className="hero__intro-sep" aria-hidden="true">/</span>
              )}
              <span className="hero__intro-term">{tech}</span>
            </Fragment>
          ))}
        </span>
      </p>

      <Link
        to="about"
        smooth
        duration={500}
        offset={-64}
        className="hero__cta"
      >
        Find out more &darr;
      </Link>
    </Element>
  );
}

export default Hero;
